import { defaultLanguage } from './../../constant';
import { Component, OnInit, HostListener , ViewChild} from '@angular/core';

import { BsModalModule } from 'ng2-bs3-modal/ng2-bs3-modal';

import { LocalStorageService } from 'angular-2-local-storage';
import { Router , ActivatedRoute, Params} from '@angular/router';
import { CookieNames, AuthTypes, BasicRoutes, LanguageSelector, AlertMessages, ApiEndpoints } from '../../constant';
import { User } from '../../model'
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
/**
 * import services
 */
import { CookieManagerService, ErrorManagerService, HttpClientService, BasicTimerService} from '../../../shared/';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../';
import { ComponentCanDeactivate } from '../../login/services/route-deactivate';

@Component({
  selector: 'app-verify',
  templateUrl: '../views/verify.component.html',
  styleUrls: ['../../../css/paper-sets.component.css','../../../css/login-selection.component.css']
})
export class VerifyComponent implements OnInit {
  
  public emailAdreess : string;
  public success : boolean = false;
  public welcomeModal : boolean = false;
  public sendEmailModal : boolean = false;

  constructor(
    private route: ActivatedRoute,
    public toastr: ToastsManager,
    private cookieManagerService: CookieManagerService,
    private ErrorManagerService: ErrorManagerService,
    private BasicTimerService : BasicTimerService,
    private translateService: TranslateService,
    private httpClientService: HttpClientService,
    private localStorageService: LocalStorageService,
    private router: Router) {}

  ngOnInit() {
  
  // this.translateService.use('en');
  var language = this.cookieManagerService.getCookie("Lang", false);
  this.translateService.use(language ? language : defaultLanguage);

    if (this.cookieManagerService.getCookie(CookieNames.loginKey, false)) {
      this.router.navigate([BasicRoutes.clientExams]);
      return;
    }

    this.route.params.forEach((params: Params) => {
        if(params['_verify'])
          this.getAccess(params['_verify']);
    });
  }

  /*
  *Send Email
  */
  sendEmail(){
    this.httpClientService.post(ApiEndpoints.getTokenAgain, {email: this.emailAdreess}).subscribe(response => {
      this.success = true;
    }, error => {
      if(error.json().code == 4016){
        this.router.navigate([BasicRoutes.clientExams]);
      }else {
        this.ErrorManagerService.commonError(error.json());
      }
    });
  }

  /*
  * Login
  */
  loginUser(user : User){
    this.cookieManagerService.setCookie(CookieNames.userobj, JSON.stringify({
        firstname : user.username,
      }), false, 1);
      this.cookieManagerService.setCookie(CookieNames.name, user.firstname && user.lastname ? user.firstname + " " + user.lastname : user.username , false, 1);
      this.cookieManagerService.setCookie(CookieNames.username, user.username, false, 1);
      this.cookieManagerService.setCookie(CookieNames.loginKey, AuthTypes.tokenPrefix + user.token, false, 1);
      this.welcomeModal = true;
      this.sendEmailModal = false;
  }

  getAccess(token){
    this.httpClientService.authGet(ApiEndpoints.verifyEmail + token, null).subscribe(response => {
        if(!response.error)
          this.loginUser(response);
    }, error => {
      if(error.json().code == 4021 ){
        this.router.navigate([BasicRoutes.login]);
        return;
      }
      this.sendEmailModal = true;
      this.welcomeModal = false;
    });
  }

  /**
   * Logout grom the application
   */
  logout() {
    this.cookieManagerService.removeCookie(CookieNames.loginKey);
    this.cookieManagerService.removeCookie(CookieNames.username);
    this.router.navigate([BasicRoutes.loginRedirect]);
    this.localStorageService.clearAll();
  }

}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/home/components/verify.component.ts